export default {
  name: "WorkCardComponent",
  props: {
    works: [Array],
    type: [String]
  }
};